import { Injectable } from '@angular/core';
import { get } from 'aws-amplify/api';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  
  private storageKey = 'selectedDate';

  constructor() {}

  saveDate(date: string): void {
    localStorage.setItem(this.storageKey, date);
  }

  saveVenue(venue: string): void {
    localStorage.setItem('selectedVenue', venue);
  }


  getDate(): string | null {
    return localStorage.getItem(this.storageKey);
  }

  
getVenue(): string | null {
    return localStorage.getItem('selectedVenue');
}

}